import Vue from 'vue'
import App from './App'
import router from './router/'
import store from './store'
import filter from './filter'
import 'vue2-datepicker/index.css'
import './axios'
import AsyncComputed from 'vue-async-computed'
import { mixin as clickaway } from 'vue-clickaway'

Vue.use(AsyncComputed)
Vue.mixin(clickaway)

Vue.config.productionTip = false

const requireComponent = require.context(
	'./components',
	// look for subfolder
	true,
	/(App|Layout)[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName)
	const componentName = fileName
		.split('/')
		.pop()
		.replace(/\.\w+$/, '')

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	)
})

require('@/assets/styles/app.scss')

new Vue({
	router,
	store,
	filter,
	render: h => h(App)
}).$mount('#app')
